import {
  ANALYTICS_SCREEN_NAMES,
  SUB_PRODUCT_AREA_NAMES,
} from '@telus-alberta-health-web/shared-module';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { Masonry } from '@leagueplatform/masonry';
import { useDocumentTitle } from '@leagueplatform/web-common';

import { MASONRY } from 'common/constants';
import { PageContentWrapper } from 'components/page-content-wrapper.component';

export const PrivacyPolicyPage = () => {
  usePageViewAnalytics({
    screen_name: ANALYTICS_SCREEN_NAMES.PRIVACY_NOTICE,
    product_area: SUB_PRODUCT_AREA_NAMES.ACCOUNT_SETUP,
  });

  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_PRIVACY_POLICY' }));

  return (
    <PageContentWrapper>
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_PRIVACY_POLICY} />
    </PageContentWrapper>
  );
};
